import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";

export default function Footer() {
    const { pathname } = useLocation();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0A0A0A] text-[#FDFBF7] relative overflow-hidden"
        >
            <div className="grain absolute inset-0" />
            <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <img
                            src="/brand/leos-luxury-logo.png"
                            alt="Leo's Luxury"
                            className="h-20 w-auto mb-6"
                        />
                        <p className="text-[#FDFBF7]/70 max-w-md leading-relaxed font-light text-sm">
                            Premium Airbnb &amp; short-term rental management for
                            Melbourne&rsquo;s west — Werribee, Point Cook, Truganina,
                            Melton, Geelong and surrounds. Higher returns, hotel-grade
                            hospitality, completely hands-off.
                        </p>
                        {pathname !== "/contact" && (
                            <Link
                                to="/contact"
                                data-testid="footer-cta-button"
                                className="btn-gold inline-block mt-8"
                            >
                                Book Free Consultation
                            </Link>
                        )}
                    </div>

                    <div className="md:col-span-3">
                        <div className="eyebrow text-gold mb-5">Explore</div>
                        <ul className="space-y-3 font-light">
                            {[
                                ["Home", "/"],
                                ["Services", "/services"],
                                ["Properties", "/properties"],
                                ["About", "/about"],
                                ["Contact", "/contact"],
                            ].map(([label, to]) => (
                                <li key={to}>
                                    <Link
                                        to={to}
                                        className="text-[#FDFBF7]/80 hover:text-gold transition-colors text-sm tracking-wide"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="eyebrow text-gold mb-5">Contact</div>
                        <ul className="space-y-4 text-sm font-light text-[#FDFBF7]/80">
                            <li className="flex items-start gap-3">
                                <Phone size={16} className="mt-1 text-gold" strokeWidth={1.2} />
                                <a href="tel:0469076071" className="hover:text-gold">
                                    0469 076 071
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail size={16} className="mt-1 text-gold" strokeWidth={1.2} />
                                <a href="mailto:leonce@leosluxury.com.au" className="hover:text-gold">
                                    leonce@leosluxury.com.au
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin size={16} className="mt-1 text-gold" strokeWidth={1.2} />
                                <span>
                                    Servicing Melbourne&rsquo;s west &amp; greater Geelong.
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <Instagram size={16} className="mt-1 text-gold" strokeWidth={1.2} />
                                <a href="#" className="hover:text-gold">
                                    @leosluxury
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="hairline my-12 opacity-40" />

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#FDFBF7]/50 tracking-wide">
                    <p>&copy; {new Date().getFullYear()} Leo&rsquo;s Luxury. All rights reserved.</p>
                    <p className="font-serif italic text-[#FDFBF7]/60">
                        Crafted with care in Melbourne.
                    </p>
                </div>
            </div>
        </footer>
    );
}
